import React from 'react';

import { SubtitleSettings, SubtitleSettingSetters } from '../types/subtitles';

export const SubtitleSettingsContext = React.createContext<SubtitleSettings>({});
export const SubtitleSettingsSettersContext = React.createContext<SubtitleSettingSetters>({});
